import { render, staticRenderFns } from "./AlmostFired.vue?vue&type=template&id=50548e1e&"
import script from "./AlmostFired.vue?vue&type=script&lang=ts&"
export * from "./AlmostFired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports